
var Backbone = require('backbone');
var _ = require('underscore');

export class Store {}

_.extend(Store.prototype, Backbone.Events);



// WEBPACK FOOTER //
// ./uikit/stores/Store.js